import { isNotNullOrUndefined } from '@vy/utils';

function extractHeadersFromHeadersObject(headers: Headers): Record<string, string> {
  const result: Record<string, string> = {};
  headers.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}

function extractHeadersFromArray(headers: [string, string][]): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of headers) {
    result[key] = value;
  }
  return result;
}

function extractHeaders(headers: HeadersInit | undefined): Record<string, string> {
  if (!isNotNullOrUndefined(headers)) {
    return {};
  }

  if (headers instanceof Headers) {
    return extractHeadersFromHeadersObject(headers);
  }

  if (Array.isArray(headers)) {
    return extractHeadersFromArray(headers);
  }

  return headers;
}

export const USE_CACHE_HEADER = async (requestContext: {
  init: RequestInit;
  context: unknown;
}): Promise<RequestInit> => {
  const { init } = requestContext;
  const existingHeaders = extractHeaders(init.headers);

  return {
    ...init,
    headers: {
      ...existingHeaders,
      'X-Use-Cache': 'true',
    },
  };
};
